import React from 'react';
import {
  addPathToList, Asset_requirements_paragraph,
  Change_paying_account, File_type, getSubCategoryId, where_your_customer_selects,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import AssetRequirements from '../components/PanelsComponents/General/AssetRequirements';

//= ========================================================================

const Panel_B08_SendMoneyPayingAccount = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
  panelHeadline,
}) => {
  const editTextList = [
    'select_paying_account',
  ];
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      onGotoEdit={onGotoEdit}
      panelHeadline={panelHeadline}
      panelSubHeadline={Change_paying_account}
      editTextList={addPathToList(editTextList, subCategoryId === 'send_money_0'
        ? `configurations/services/${subCategoryId}/amount/` : `configurations/services/${subCategoryId}/amount_package/`)}
      tooltipsTitles={globJSON.configurations.services[subCategoryId].screens_ordering}
      paragraph={where_your_customer_selects}
      language={language}
    >
      <AssetRequirements paragraph={Asset_requirements_paragraph} details={File_type} />
    </FullPagePanel>
  );
};

export default Panel_B08_SendMoneyPayingAccount;
